<div class="error_page">
  <div class="error_page_name">&nbsp;</div>
  <img src="/assets/img/404-error.png" alt="" class="error_page_img">
  <div class="error_page_title">Whoops!</div>
  <div class="error_page_text">Looks like you have some problems with internet connection. Please, refresh the webpage.</div>
</div>
<div id="roadmap-paint-finished"></div>
